import Cookies from 'js-cookie';
import { STRINGS } from 'config';

const { SI_SUITE_DOMAIN } = STRINGS.API;

export const getPracticeCookie = () => Cookies.get('selectedPractice');

export const setPracticeCookie = practiceId => (
  Cookies.set('selectedPractice', practiceId, { domain: SI_SUITE_DOMAIN, expires: 365, sameSite: 'lax' })
);
